function OsrSupportButton(element) {
    this.element = element;
    this.eye = this.element.querySelector('.jsOsrSupportBtnEye');

    this.setElementPositions();
    window.addEventListener('resize', _ => this.setElementPositions());

    window.addEventListener('mousemove', e => gsap.set(this.eye, { rotation: (this.calcDegrees(e.clientX, e.clientY, this.elXCenter, this.elYCenter) + 90) + 'deg' }));
}

OsrSupportButton.prototype.setElementPositions = function() {
    const bounds = this.element.getBoundingClientRect();

    this.elXCenter = bounds.x + (bounds.width / 2);
    this.elYCenter = bounds.y + (bounds.height / 2);
};

OsrSupportButton.prototype.calcDegrees = function(mouseX, mouseY, elCenterX, elCenterY) {
    const radians = Math.atan2(mouseX - elCenterX, mouseY - elCenterY);
    return (radians * (180 / Math.PI) * -1) + 90;
}